import { gql } from '@apollo/client';

export const fetchPaymentMethodsForInvoiceGroup = gql`
  query fetchPaymentMethodsForInvoiceGroup($id: ID!) {
    invoiceGroup(id: $id) {
      id
      availablePaymentMethods {
        totalCount
        nodes {
          id
          type
          default
          paymentIssue
          ... on CreditCard {
            card {
              expirationMonth
              expirationYear
              last4Numbers
              brand
            }
          }
          ... on PaymentOnTerms {
            terms {
              invoiceDueDays
            }
          }
        }
      }
    }
  }
`;
